import BankAcccountVerification from "./containers";

export default BankAcccountVerification;
